import {
	GET_ALL_PRODUCTTYPES,
	SAVE_PRODUCTTYPE,
	DELETE_PRODUCTTYPE
} from '../../Actions/Admin/ManageProductTypeAction';

const initialState = {
	productTypes: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ALL_PRODUCTTYPES:
			return {
				...state,
				loading: true,
				productTypes: action.payload
			};
		
		case SAVE_PRODUCTTYPE:
			return {
				...state,
				productTypes: action.payload
			};
		case DELETE_PRODUCTTYPE:
			return {
				...state,
				productTypes: action.payload
			};
		default:
			return state;
	}
};
